import React from 'react';
import { EXTERNAL_LINKS } from 'core/links';

const FeedBack = () => {
    return (
        <div className="container">
            <h4 className="text-3572EF mb-4 mt-2">Feedback</h4>
            {/* Embedded SurveyMonkey form using an iframe */}
            <div className='w-100 m-auto'>
                <iframe
                    src={EXTERNAL_LINKS.FEEDBACK_SURVEY}
                    width="100%"
                    height="1400"
                    title="SurveyMonkey Feedback Form"
                ></iframe>
            </div>
        </div>
    );
};

export default FeedBack;
